import React, { FC, ReactNode } from 'react';
import { ComparatorSymbolByString } from '@/common/const';
import { Maybe } from '@/common/types';
import { SliderArrowDownIcon } from '@/components/common/Icons/SliderArrowDownIcon';
import { FactorCategory } from '../types/FactorCategory.enum';
import { OutcomeCategory } from '../types/OutcomeCategory.enum';
import { OutcomeFactor } from '../types/types';
import {
    OutcomeSliderWrapper,
    OutcomeSliderFactors,
    OutcomeSliderSlot,
    OutcomeSliderFactor,
    OutcomeSliderFactorDescription,
} from './styles';

interface OutcomeSliderProps {
    outcomeSliderData: {
        factors: Maybe<OutcomeFactor[]>;
        factorResultCategory: Maybe<FactorCategory>;
    };
    showCriteria;
    type: Maybe<OutcomeCategory>;
}

export const OutcomeSlider: FC<OutcomeSliderProps> = ({ outcomeSliderData, showCriteria = false, type }) => {
    const { factors, factorResultCategory } = outcomeSliderData;
    const OutcomeSliderSlots: ReactNode[] = [];
    const OutcomeSliderFactorTargets: ReactNode[] = [];
    const OutcomeSliderFactorDescriptions: ReactNode[] = [];
    const OutcomeSliderFactorShortDescriptions: ReactNode[] = [];
    const OutcomeSliderFactorCriteria: ReactNode[] = [];

    factors?.forEach((factor, index) => {
        OutcomeSliderSlots.push(
            <OutcomeSliderSlot $factorCategory={factor.category} $isActive={factorResultCategory === factor.category}>
                <SliderArrowDownIcon fontSize="inherit" />
            </OutcomeSliderSlot>,
        );
        OutcomeSliderFactorTargets.push(
            <OutcomeSliderFactor
                $factorCategory={factor.category}
                $tremorIndex={type === OutcomeCategory.TREMORS ? index : undefined}
            >
                {' '}
            </OutcomeSliderFactor>,
        );
        OutcomeSliderFactorDescriptions.push(
            <OutcomeSliderFactorDescription $factorCount={factors.length}>
                {factor.description}
            </OutcomeSliderFactorDescription>,
        );

        OutcomeSliderFactorShortDescriptions.push(
            <OutcomeSliderFactorDescription $factorCount={factors.length}>
                {factor.shortDescription}
            </OutcomeSliderFactorDescription>,
        );

        // outcomes with sliders do not have multiple criteria
        const criteria = factor.criteria[0];
        OutcomeSliderFactorCriteria.push(
            <OutcomeSliderFactorDescription $factorCount={factors.length}>
                {criteria.conditions
                    .map((c) => `${ComparatorSymbolByString[c.comparator]} ${c.value} ${criteria.units}`)
                    .join(' & ')}
            </OutcomeSliderFactorDescription>,
        );
    });

    return (
        <OutcomeSliderWrapper>
            <OutcomeSliderFactors>{OutcomeSliderSlots}</OutcomeSliderFactors>
            <OutcomeSliderFactors>{OutcomeSliderFactorTargets}</OutcomeSliderFactors>
            <OutcomeSliderFactors>{OutcomeSliderFactorDescriptions}</OutcomeSliderFactors>
            <OutcomeSliderFactors>{OutcomeSliderFactorShortDescriptions}</OutcomeSliderFactors>
            {showCriteria && <OutcomeSliderFactors>{OutcomeSliderFactorCriteria}</OutcomeSliderFactors>}
        </OutcomeSliderWrapper>
    );
};
